import React from 'react';
import { MenuLevel } from '../models';
import MegaMenuElement from './MegaMenuElement';

interface MegaMenuLevelProps {
    activePath: number[];
    realPath: number[];
    elements: MenuLevel[];
    level: number;
    onActivate: (path: number[]) => void;
}

export default class MegaMenuLevel extends React.Component<MegaMenuLevelProps> {
    render(): JSX.Element | null {
        const { level, elements, activePath, realPath } = this.props;
        const activeIndex = realPath[level - 1];
        const hasChildren = activeIndex !== undefined && elements[activeIndex]?.children?.length;

        return (
            <>
                <div className={`mega-menu__level mega-menu__level--${level}`}>
                    {elements.map((child, index) => (
                        <MegaMenuElement
                            key={index}
                            element={child}
                            level={level}
                            onActivate={(e) => this.onActivate(index, e)}
                            isActive={activeIndex === index}
                            activePath={activePath}
                            showChildren={false}
                        />
                    ))}
                </div>
                {hasChildren && (
                    <MegaMenuLevel
                        elements={elements[activeIndex!]!.children}
                        level={level + 1}
                        activePath={activePath}
                        realPath={realPath}
                        onActivate={(path) => this.onActivateLevel(path)}
                    />
                )}
            </>
        );
    }

    onActivate(index: number, path: number[]): void {
        this.props.onActivate([index, ...path]);
    }

    onActivateLevel(path: number[]): void {
        this.props.onActivate([...this.props.realPath.slice(this.props.level - 1, this.props.level), ...path]);
    }
}
